var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5537 14.8428C19.575 13.1895 20.4629 11.6251 21.8715 10.7591C20.9829 9.49005 19.4945 8.68542 17.946 8.63697C16.2944 8.46361 14.6933 9.62526 13.8516 9.62526C12.9937 9.62526 11.6979 8.65418 10.3026 8.68289C8.48375 8.74165 6.78816 9.77573 5.90327 11.3659C4.00111 14.6591 5.41995 19.4992 7.24206 22.1612C8.1537 23.4648 9.21915 24.9208 10.6133 24.8692C11.9775 24.8126 12.487 23.9993 14.1337 23.9993C15.7652 23.9993 16.2432 24.8692 17.6656 24.8364C19.1295 24.8126 20.0518 23.527 20.9315 22.2112C21.5865 21.2824 22.0905 20.2558 22.4249 19.1696C20.7046 18.442 19.5557 16.7107 19.5537 14.8428Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.867 6.88628C17.6652 5.92811 18.0584 4.69654 17.9632 3.45312C16.7438 3.5812 15.6174 4.16401 14.8084 5.08541C14.0174 5.98567 13.6057 7.19557 13.6835 8.39146C14.9034 8.40402 16.1026 7.83702 16.867 6.88628Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b18835ff48ffec8be8fe5b4e23e98889.svg";
export { ForwardRef as ReactComponent };